module.exports = __webpack_public_path__ + "img/img-carrusel-personas-1-mobile.84da192.webp";